export default {"src":"/_next/static/media/questions-hero.80e9ab30.svg","height":288,"width":805};